<template>
  <b-modal ref="paperResultModal" title="Ergebnis eintragen" size="lg">
    <b-alert :variant="alert.variant" :show="alert.show" class="text-center">{{ alert.message }}</b-alert>
    <b-form>
      <b-form-group label="Name" label-for="name" label-cols=12 label-cols-lg=2>
        <b-form-input name="name" v-model="name" required></b-form-input>
      </b-form-group>

      <b-form-group label="Klassenstufe" label-for="age" label-cols=12 label-cols-lg=2 description="Erst- und Zweitklässler nehmen als Drittklässler teil">
        <b-form-select name="age" v-model="age" :options="this.ages"></b-form-select>
      </b-form-group>

      <b-card v-if="age" v-for="(cat, catIndex) in this.categories" :key="cat.id" class="mb-3">
          <h6>{{ cat.name }} </h6>

          <b-form-group
            v-for="(question, id) in questions[cat.id]"
            :key="id"
            :label="((catIndex * 15) + question.position).toString()"
            horizontal
            class="paperResultModalQuestion">
            <b-form-radio-group :name="'radio_' + question.id" v-model="answers[question.id]">
              <b-form-radio value="a">A</b-form-radio>
              <b-form-radio value="b">B</b-form-radio>
              <b-form-radio value="c">C</b-form-radio>
              <b-form-radio value=null class="ml-5">Nicht beantwortet</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

      </b-card>
    </b-form>

    <template slot="modal-footer">
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
      <b-btn class="mt-3" variant="danger" block @click="save">Speichern</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'PaperResultModal',
  props: ['competitionId', 'registrationId'],

  data: function () {
    return {
      token: null,
      name: '',
      age: null,
      ages: [{text: 'Bitte wählen...', value: null, disabled: true}, 3, 4, 5, 6, 7, 8],
      categories: [],
      questions: {},
      answers: {},
      alert: {
        variant: 'danger',
        message: '',
        show: false
      },
      ageOptions: {
        3: [3, 4],
        4: [3, 4],
        5: [5, 6],
        6: [5, 6],
        7: [7, 8],
        8: [7, 8]
      }
    }
  },

  watch: {
    age: function () {
      this.load()
    },
    name: function () {
      this.alert.show = false
    }
  },

  methods: {
    show: function (row) {
      this.$eventHub.$emit('alertHide')

      if (row) {
        this.age = row.age
        this.token = row.token
        this.name = row.name

        if (row.answers) {
          Object.keys(row.answers).forEach((questionId) => {
            this.$set(this.answers, questionId, row.answers[questionId])
          })
        } else {
          this.$set(this, 'answers', {})
        }
      } else {
        this.token = null
        this.name = ''
        this.age = null
      }

      this.$refs.paperResultModal.show()
    },

    hide: function () {
      this.loading = true
      this.$refs.paperResultModal.hide()
    },

    save: function () {
      if (this.name === '') {
        this.alert.variant = 'danger'
        this.alert.message = 'Bitte tragen Sie einen Namen ein'
        this.alert.show = true
        return
      }

      if (!this.age) {
        this.alert.variant = 'danger'
        this.alert.message = 'Bitte wählen Sie eine Klassenstufe'
        this.alert.show = true
        return
      }

      let answers = {}

      Object.keys(this.answers).forEach((key) => {
        if (this.answers[key] !== null && this.answers[key] !== 'null') {
          answers[key] = this.answers[key]
        }
      })

      let body = {
        name: this.name,
        age: this.age,
        registrationId: parseInt(this.registrationId),
        answers: answers
      }

      let req = null
      if (this.token == null) {
        req = this.axios.post('/quiz/paper', JSON.stringify(body))
      } else {
        req = this.axios.patch('/quiz/results/' + this.token, JSON.stringify(body))
      }

      req.then((rsp) => {
        this.$set(this, 'token', null)
        this.$set(this, 'name', '')
        this.$set(this, 'age', null)
        this.$set(this, 'answers', {})
        this.$emit('update')

        let message = 'Ergebnis eingetragen. Der Schüler hat ' + rsp.data.points + ' Punkte erreicht.'
        this.$eventHub.$emit('info', message)

        this.hide()
      })
    },

    load: function () {
      if (!this.age) {
        return
      }

      this.questions = {}
      this.categories = []

      this.axios.get('/competitions/' + this.competitionId + '/categories')
        .then((rsp) => {
          rsp.data.forEach((category) => {
            let categoryId = category.id
            this.categories.push(category)
            this.$set(this.questions, categoryId, [])
          })
        })
        .then(() => {
          this.axios.get('/competitions/' + this.competitionId + '/questions?age=' + this.age)
            .then((rsp) => {
              rsp.data.forEach((q) => {
                this.questions[q.categoryId].push(q)
              })
            })
        })
    }
  }
}
</script>
<style scoped>
  .paperResultModalQuestion {
    margin-bottom: 0;
  }
  .paperResultModalQuestion:hover {
    background-color: #F3F3F3;
  }
</style>



// WEBPACK FOOTER //
// src/components/competitions/details/PaperResultModal.vue